var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full mt-10 flex"},[_c('div',{staticClass:"w-90 px-1 py-3 rounded border-gray-500 mx-auto"},[_c('ChangeEmail')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }